<div class="mct-flex mct-col mct-gap-8" *ngIf="openFieldData">
  <h4>
    {{ 'form-builder.legos.open-field.description-text' | translate | ucfirst }}
  </h4>
  <div class="mct-flex mct-col mct-gap-5">
    <label> {{ 'form-builder.legos.open-field.question-text-label' | translate | ucfirst }} </label>
    <input name="openFieldLabel" class="form-control" [(ngModel)]="openFieldData.Label" />
  </div>
  <hr />
  <div class="mct-flex mct-col mct-gap-5">
    <label> {{ 'form-builder.legos.open-field.field-type-label' | translate | ucfirst }} </label>
    <div class="mct-flex mct-justify-start mct-items-center mct-gap-4 mt-4">
      <p-radioButton
        [(ngModel)]="openFieldData.OpenFieldType"
        name="openFieldType"
        [value]="openFieldType.Textbox"
        inputId="openFieldTextbox"
      >
      </p-radioButton><label for="openFieldTextbox">
      {{ 'form-builder.legos.open-field.type.textbox' | translate | titlecase }}
    </label>
    </div>

    <div class="mct-flex mct-justify-start mct-items-center mct-gap-4 mt-4">
      <p-radioButton
        [(ngModel)]="openFieldData.OpenFieldType"
        name="openFieldType"
        [value]="openFieldType.Dropdown"
        inputId="openFieldDropdown"
      >
      </p-radioButton><label for="openFieldDropdown">
      {{ 'form-builder.legos.open-field.type.dropdown' | translate | titlecase }}
    </label>

    </div>

    <div class="mct-flex mct-justify-start mct-items-center mct-gap-4 mt-4">
      <p-radioButton
        [(ngModel)]="openFieldData.OpenFieldType"
        name="openFieldType"
        [value]="openFieldType.CheckboxList"
        inputId="openFieldCheckboxList"
      >
      </p-radioButton><label for="openFieldCheckboxList">
      {{ 'form-builder.legos.open-field.type.checkbox-list' | translate | titlecase }}
    </label>
    </div>


  </div>
  <div
    [ngSwitch]="openFieldData.OpenFieldType"
    *ngIf="openFieldData.OpenFieldType > openFieldType.Textbox"
    class="mct-flex mct-col"
  >
    <div class="atlas-autocomplete">
      <label *ngSwitchCase="openFieldType.CheckboxList">
        {{ 'form-builder.legos.open-field.checkbox-options-label' | translate | ucfirst }}
      </label>
      <label *ngSwitchCase="openFieldType.Dropdown">
        {{ 'form-builder.legos.open-field.drop-down-options-label' | translate | ucfirst }}
      </label>
      <p-autocomplete
        #chips
        name="chips"
        appendTo="body"
        [addOnTab]="true"
        [addOnBlur]="true"
        seperator=","
        [multiple]="true"
        [typeahead]="false"
        [suggestions]="[]"
        (completeMethod)="primeChipCompleteMethod()"
        [(ngModel)]="openFieldData.Options">
      </p-autocomplete>
    </div>
  </div>
  <div class="mct-flex mct-justify-start mct-items-center mct-gap-4 mt-4">
    <p-checkbox [(ngModel)]="openFieldData.Required" name="required" [binary]="true" inputId="required"> </p-checkbox>
    <label for="required">
      {{ 'common.required' | translate | titlecase }}
    </label>
  </div>
</div>
